export default __webpack_public_path__ + "static/media/blocks.43357afd.png";